
































import MainView from '@/components/main-view.vue'
import DragSurface from '@/components/drag-surface.vue'
import ConnexionCheck from '@/components/connexion-check.vue'
// import NewsModal from '@/components/news-modal.vue'
import RulesAcceptation from '@/components/rules-acceptation.vue'
import ModalDialog from '@/components/modal-dialog'
import UpdateProgress from '@/components/update-progress'

// import { init as analytics } from '@/plugins/analytics'

import Moment from 'moment-timezone/builds/moment-timezone-with-data-2012-2022'
import Vue from 'vue'

export default {
  name: 'app',
  components: { MainView, DragSurface, ConnexionCheck, RulesAcceptation, ModalDialog, UpdateProgress },
  computed: {
    routeParams() {
      let layer
      let altitude
      if (this.$route.params.layer !== undefined) {
        const split = this.$route.params.layer.split('@')
        layer = split[0]
        altitude = parseInt(split[1], 10)
      }
      return {
        lat: this.$route.params.lat,
        lon: this.$route.params.lon,
        zoom: this.$route.params.zoom,
        layer,
        altitude
      }
    },
    lang() {
      return this.$store.state.persistent.lang
    },
    ready() {
      return (this.$store.state.time.cursor !== undefined) && (this.modal !== 'app-market-update')
    },
    appVersion() {
      return this.$store.state.time.appVersion
    },
    cordova() {
      return this.$store.state.runtime.cordova
    },
    appIsUpdating() {
      return this.$store.state.time.appIsUpdating
    },
    needAppMarketUpdate() {
      return this.$store.state.time.needAppMarketUpdate
    },
    modal() {
      return this.$store.state.runtime.modal
    },
    networkError() {
      return this.$store.state.time.networkError
    }
  },
  watch: {
    needAppMarketUpdate() {
      if (this.needAppMarketUpdate !== false) {
        this.$store.dispatch('runtime/showModal', 'app-market-update')
      }
    },
    $route() {
      this.updateLocation()
    },
    lang() {
      this.updateTitle()
      this.$store.dispatch('news/fetch')
    },
    ready(isReady, wasReady) {
      if (!isReady || wasReady) return
      if ('cordova' in window) {
        this.$store.dispatch('persistent/incrementAppOpenCount')

        window.AppRate.preferences.storeAppURL = {
          ios: '1255974302',
          android: 'market://details?id=com.meteo_parapente'
        }
        window.AppRate.preferences.usesUntilPrompt = 10
        window.AppRate.preferences.useLanguage = this.$store.state.persistent.lang
        window.AppRate.promptForRating(false)
      }
    }
  },
  methods: {
    updateLocation() {
      const degreesCheck = /^-?\d+(\.\d+)?$/
      const zoomCheck = /^(\d*)$/
      const layerCheck = /^([a-z0-9]*)$/
      const altitudeCheck = /^(\d*)$/
      // console.log(this.routeParams)
      if (!degreesCheck.test(this.routeParams.lat)) return false
      if (!degreesCheck.test(this.routeParams.lon)) return false
      if (!zoomCheck.test(this.routeParams.zoom)) return false
      if (!layerCheck.test(this.routeParams.layer)) this.routeParams.layer = null
      if (!altitudeCheck.test(this.routeParams.altitude)) this.routeParams.altitude = null
      this.$store.dispatch('persistent/setRouteParams', this.routeParams)
      return true
    },
    updateTitle() {
      document.title = this.$pgettext('application title', 'Soaring weather forecasts | Meteo-Parapente.com')
    },
    resume() {
      if (new Date() - this.$store.state.time.updateTime > 2 * 3600 * 1000) {
        window.location.reload(false)
      }
    },
    initCordova() {
      this.$store.dispatch('runtime/toggleCordova')

      document.addEventListener('resume', this.resume, false)
      // document.addEventListener('pause', onResume, false)

      window.openLink = function (url) {
        window.open(url, '_system')
      }

      window.alert = function (content) {
        navigator.notification.alert(content, null, ' ')
      }

      window.promptAsync = function (content, callback) {
        const awaiter = function (result) {
          if (result.buttonIndex === 1) {
            return callback(result.input1)
          }
        }
        navigator.notification.prompt(content, awaiter, ' ')
      }

      window.confirmAsync = function (content, callback, error) {
        const awaiter = function (buttonIndex) {
          if (buttonIndex === 1) {
            callback()
          } else if (error !== undefined) {
            error()
          }
        }
        navigator.notification.confirm(content, awaiter, ' ')
      }
    },
    detectTouchscreen() {
      const listener = () => {
        this.$store.dispatch('runtime/setTouchscreen', true)
        window.removeEventListener('touchstart', listener)
        console.log('touchscreen detected')
      }
      window.addEventListener('touchstart', listener)
    }
  },
  created() {
    Vue.config.server = '_mtopara_dev_' in window ? 'https://dev.meteo-parapente.com' : 'https://meteo-parapente.com'
    // Vue.config.server = 'https://meteo-parapente.com'

    if ('cordova' in window) {
      this.initCordova()
    }
    this.$store.dispatch('persistent/syncConfig')
    this.updateTitle()

    this.$store.dispatch('persistent/load', this.$store.getters['favorites/home'])
    this.$store.dispatch('time/fetchSegments', false)
    setInterval(() => this.$store.dispatch('time/fetchSegments', true), 5 * 60 * 1000)

    const needLocate = !this.updateLocation() && this.$store.state.persistent.center.defaultValues
    if (needLocate) {
      this.$store.dispatch('persistent/setUserLocation')
    }
    this.$store.dispatch('news/fetch')

    if (!this.$store.state.persistent.timezoneOveride) {
      const timezone = Moment.tz.guess()
      this.$store.dispatch('persistent/setTimezone', timezone)
    }

    this.detectTouchscreen()

    if (document.location.hash === '#/contribute') {
      document.location = window.portalLink('users/contribute/')
    } else if (document.location.hash === '#/password') {
      this.$store.dispatch('runtime/showModal', 'password')
    }
  },
  mounted() {
    /* window.ga = analytics()

    let page
    if ('cordova' in window) {
      page = `/app-${window.device.platform}/${this.lang}`
    } else {
      page = `/web/${this.lang}`
    }
    window.ga('set', {
      page,
      title: this.$route.name
    })
    window.ga('send', 'pageview')
    /* this.$router.afterEach((to, from) => {
      window.ga('set', {
        page: to.path,
        title: to.name
      })
      window.ga('send', 'pageview')
    }) */
  }
}



// WEBPACK FOOTER //
// ./src/routes/app/template.vue